import React, { useState } from "react";
import "./RegisterScreen.css";
import BackButton from "../../components/BackButton/BackButton";
import Button from "../../components/Button/Button";
import Header from "../../components/Header/Header";
import TextInput from "../../components/TextInput/TextInput";
import { nameValidator } from "../../helpers/nameValidator";

/** Firebase Imports **/
import {
	auth,
	createUserWithEmailAndPassword,
	updateProfile,
	collection,
	db,
	setDoc,
	doc,
} from "../../firebaseConfig";
import { logIn, useDispatch } from "../../features/userSlice";
import { showError } from "../../helpers/showError";
/** **/

const RegisterScreenNext = ({ email, password, allowStep2 }) => {
	const dispatch = useDispatch();
	const [name, setName] = useState({ value: "", error: "" });
	const [isProcessing, setIsProcessing] = useState(false);

	/**
	 * Main Functions
	 */
	const handleSignUp = () => {
		const nameError = nameValidator(name.value);
		if (nameError) {
			setName({ ...name, error: nameError });
			return;
		}

		setIsProcessing(true);
		createUserWithEmailAndPassword(auth, email, password)
			.then((userCredential) => {
				// Signed in
				updateProfile(auth.currentUser, {
					displayName: name.value,
				}).then(async () => {
					const usersRef = collection(db, "users");
					await setDoc(doc(usersRef, auth.currentUser.uid), {
						userName: "",
						isAdmin: false,
					})
						.then(() => {
							//username updated
							dispatch(
								logIn({
									uid: userCredential.user.uid,
									email: userCredential.user.email,
									name: userCredential.user.displayName,
									role: "user",
								})
							);
						})
						.catch((error) => showError(error));
					setIsProcessing(false);
					// alert("Successful Register");
					// navigate("/landing");
				});
			})
			.catch((error) => {
				setIsProcessing(false);
				showError(error);
			});
	};
	/** **/

	return (
		<div className="RegisterScreenNext h-full w-full m-0 p-3 py-8 flex flex-col items-center">
			<BackButton
				target={false}
				setFunction={allowStep2}
				value={false}
				className="mr-auto"
			/>
			<Header className={"my-8 mr-auto"} size={"large"}>
				Register
			</Header>
			<TextInput
				className={"my-2"}
				type={"text"}
				name={"name"}
				id={"name"}
				placeholder={"Name"}
				value={name.value}
				onChange={(e) => {
					setName({ value: e.target.value, error: "" });
				}}
				error={name.error !== ""}
				errorMessage={name.error}
			/>
			<Button
				className={"my-2"}
				title={isProcessing ? "ooo" : "SIGN UP"}
				disabled={isProcessing}
				mode={"filled"}
				size={"full"}
				onClick={(e) => handleSignUp()}
			/>

			<p className="bottom-text mt-8">
				By signing up, you agree to Jones’s Trucking’s{" "}
				<span className="underline">Terms of Service</span> and{" "}
				<span className="underline">Privacy Policy</span>.
			</p>
		</div>
	);
};

export default RegisterScreenNext;
